// Area Summaries Data
export const areaSummariesData = {
  2024: {
    operations: {
      status: "attention",
      phrase: { en: "Operational execution below plan with moderate impact on production and efficiency.", pt: "Execução operacional abaixo do plano com impacto moderado na produção e eficiência." },
      miniKpis: [
        { id: "ore_processed", label: { en: "Ore Treated", pt: "Minério Tratado" }, value: "4.28M", variance: "-2.7%", yoy: "+5.7%", link: "/operations?section=overview-2025" },
        { id: "grade", label: { en: "Average Grade", pt: "Teor Médio" }, value: "16.02 cpht", variance: "+1.5%", yoy: "+2.1%", link: "/operations?section=overview-2025" },
        { id: "recovery", label: { en: "Recovery", pt: "Recuperação" }, value: "93.8%", variance: "+0.8%", yoy: "+1.2%", link: "/operations?section=overview-2025" },
        { id: "strip_ratio", label: { en: "Strip Ratio", pt: "Strip Ratio" }, value: "1.95:1", variance: "+7.1%", yoy: "+4.9%", link: "/operations?section=overview-2025" },
      ],
    },
    finance: {
      status: "inline",
      phrase: { en: "Financial performance under control with focus on margin, cash and investment discipline.", pt: "Performance financeira sob controlo com foco em margem, caixa e disciplina de investimento." },
      miniKpis: [
        { id: "revenue", label: { en: "Revenue", pt: "Receita" }, value: "250M", variance: "+2.1%", yoy: "+5.8%", link: "/finance?section=revenue-detail" },
        { id: "ebitda_margin", label: { en: "EBITDA Margin", pt: "Margem EBITDA" }, value: "40.1%", variance: "+1.8pp", yoy: "+2.5pp", link: "/finance?section=ebitda-detail" },
        { id: "cash", label: { en: "Cash", pt: "Caixa" }, value: "42.1M", variance: "+5.3%", yoy: "+12.4%", link: "/finance?section=liquidity" },
        { id: "capex_exec", label: { en: "CAPEX Exec.", pt: "Exec. CAPEX" }, value: "87%", variance: "-3%", yoy: "+4.2%", link: "/finance?section=capex" },
      ],
    },
    hr: {
      status: "inline",
      phrase: { en: "Organizational capacity stable with focus on retention and critical positions.", pt: "Capacidade organizacional estável com foco em retenção e posições críticas." },
      miniKpis: [
        { label: { en: "Headcount", pt: "Efectivos" }, value: "1,842", trend: "neutral" },
        { label: { en: "Turnover", pt: "Rotatividade" }, value: "8.2%", trend: "up" },
        { label: { en: "Critical Roles", pt: "Funções Críticas" }, value: "91%", trend: "down" },
        { label: { en: "Training", pt: "Formação" }, value: "85%", trend: "neutral" },
      ],
    },
    esg: {
      status: "strong",
      phrase: { en: "ESG profile controlled with focus on safety, environment and license to operate.", pt: "Perfil ESG controlado com foco em segurança, ambiente e licença para operar." },
      miniKpis: [
        { label: { en: "LTIFR", pt: "LTIFR" }, value: "0.42", trend: "down" },
        { label: { en: "Env. Incidents", pt: "Inc. Ambientais" }, value: "2", trend: "down" },
        { label: { en: "Rehabilitation", pt: "Reabilitação" }, value: "78%", trend: "up" },
        { label: { en: "Community", pt: "Comunidade" }, value: "94%", trend: "up" },
      ],
    },
  },
  2025: {
    operations: {
      status: "attention",
      phrase: { en: "Operational execution improving with solid recovery rates.", pt: "Execução operacional a melhorar com taxas de recuperação sólidas." },
      miniKpis: [
        { id: "ore_processed", label: { en: "Ore Treated", pt: "Minério Tratado" }, value: "1.08M", variance: "-6%", yoy: "+4.2%", link: "/operations?section=overview-2026" },
        { id: "grade", label: { en: "Average Grade", pt: "Teor Médio" }, value: "15.8 cpht", variance: "-2.1%", yoy: "+1.5%", link: "/operations?section=overview-2026" },
        { id: "recovery", label: { en: "Recovery", pt: "Recuperação" }, value: "94.2%", variance: "+1.2%", yoy: "+0.8%", link: "/operations?section=overview-2026" },
        { id: "strip_ratio", label: { en: "Strip Ratio", pt: "Strip Ratio" }, value: "1.94:1", variance: "+7.6%", yoy: "+5.4%", link: "/operations?section=overview-2026" },
      ],
    },
    finance: {
      status: "strong",
      phrase: { en: "Strong financial performance with improved margins.", pt: "Forte performance financeira com margens melhoradas." },
      miniKpis: [
        { id: "revenue", label: { en: "Revenue", pt: "Receita" }, value: "85.2M", variance: "+5%", yoy: "+8.2%", link: "/finance?section=revenue-detail" },
        { id: "ebitda_margin", label: { en: "EBITDA Margin", pt: "Margem EBITDA" }, value: "37.8%", variance: "+2.3pp", yoy: "+3.1pp", link: "/finance?section=ebitda-detail" },
        { id: "cash", label: { en: "Cash", pt: "Caixa" }, value: "45.3M", variance: "-8%", yoy: "+12.5%", link: "/finance?section=liquidity" },
        { id: "capex_exec", label: { en: "CAPEX Exec.", pt: "Exec. CAPEX" }, value: "82%", variance: "-5%", yoy: "+6.2%", link: "/finance?section=capex" },
      ],
    },
    hr: {
      status: "attention",
      phrase: { en: "Workforce stability improved with lower turnover.", pt: "Estabilidade da força de trabalho melhorada." },
      miniKpis: [
        { id: "headcount", label: { en: "Headcount", pt: "Efectivos" }, value: "2,012", variance: "+3%", yoy: "+5.2%", link: "/hr" },
        { id: "turnover", label: { en: "Turnover", pt: "Rotatividade" }, value: "7.5%", variance: "+1.2pp", yoy: "-0.8pp", link: "/hr" },
        { id: "critical", label: { en: "Critical Roles", pt: "Funç. Críticas" }, value: "92%", variance: "-3%", yoy: "+1.5%", link: "/hr" },
        { id: "training", label: { en: "Training", pt: "Formação" }, value: "88%", variance: "-4%", yoy: "+3.2%", link: "/hr" },
      ],
    },
    esg: {
      status: "strong",
      phrase: { en: "Excellent ESG performance with leading safety metrics.", pt: "Excelente performance ESG com métricas de segurança líderes." },
      miniKpis: [
        { id: "ltifr", label: { en: "LTIFR", pt: "LTIFR" }, value: "0.35", variance: "-12%", yoy: "-18%", link: "/esg" },
        { id: "env", label: { en: "Env. Incidents", pt: "Inc. Ambientais" }, value: "1", variance: "=", yoy: "-50%", link: "/esg" },
        { id: "rehab", label: { en: "Rehabilitation", pt: "Reabilitação" }, value: "89%", variance: "+4%", yoy: "+11%", link: "/esg" },
        { id: "community", label: { en: "Community", pt: "Comunidade" }, value: "95%", variance: "-2%", yoy: "+1%", link: "/esg" },
      ],
    },
  },
  2026: {
    operations: {
      status: "attention",
      phrase: { en: "Q1 production facing challenges with ore processing below target.", pt: "Produção do 1T a enfrentar desafios com processamento de minério abaixo do objectivo." },
      miniKpis: [
        { id: "ore_processed", label: { en: "Ore Treated", pt: "Minério Tratado" }, value: "1.08M", variance: "-6%", yoy: "+4.2%", link: "/operations?section=overview-2026" },
        { id: "grade", label: { en: "Average Grade", pt: "Teor Médio" }, value: "15.8 cpht", variance: "-2.1%", yoy: "+1.5%", link: "/operations?section=overview-2026" },
        { id: "recovery", label: { en: "Recovery", pt: "Recuperação" }, value: "94.2%", variance: "+1.2%", yoy: "+0.8%", link: "/operations?section=overview-2026" },
        { id: "strip_ratio", label: { en: "Strip Ratio", pt: "Strip Ratio" }, value: "1.94:1", variance: "+7.6%", yoy: "+5.4%", link: "/operations?section=overview-2026" },
      ],
    },
    finance: {
      status: "strong",
      phrase: { en: "Q1 financial resilience maintained with growing EBITDA vs Budget.", pt: "Resiliência financeira do 1T mantida com EBITDA a crescer vs Orçamento." },
      miniKpis: [
        { id: "revenue", label: { en: "Revenue", pt: "Receita" }, value: "85.2M", variance: "+5%", yoy: "+8.2%", link: "/finance?section=revenue-detail-2026" },
        { id: "ebitda_margin", label: { en: "EBITDA Margin", pt: "Margem EBITDA" }, value: "37.8%", variance: "+2.3pp", yoy: "+1.5pp", link: "/finance?section=ebitda-detail-2026" },
        { id: "cash", label: { en: "Cash", pt: "Caixa" }, value: "45.3M", variance: "-8%", yoy: "+8.5%", link: "/finance?section=liquidity-2026" },
        { id: "capex_exec", label: { en: "CAPEX Exec.", pt: "Exec. CAPEX" }, value: "82%", variance: "-5%", yoy: "-3.2%", link: "/finance?section=capex-2026" },
      ],
    },
    hr: {
      status: "attention",
      phrase: { en: "Q1 turnover increase in critical functions requiring focus.", pt: "Aumento da rotatividade no 1T em funções críticas a exigir foco." },
      miniKpis: [
        { id: "headcount", label: { en: "Headcount", pt: "Efectivos" }, value: "2,012", variance: "+3%", yoy: "+2.1%", link: "/hr" },
        { id: "turnover", label: { en: "Turnover", pt: "Rotatividade" }, value: "7.5%", variance: "+1.2pp", yoy: "+0.5pp", link: "/hr" },
        { id: "critical", label: { en: "Critical Roles", pt: "Funç. Críticas" }, value: "92%", variance: "-3%", yoy: "-1.2%", link: "/hr" },
        { id: "training", label: { en: "Training", pt: "Formação" }, value: "88%", variance: "-4%", yoy: "+2.5%", link: "/hr" },
      ],
    },
    esg: {
      status: "strong",
      phrase: { en: "Q1 ESG profile strong with continued safety improvements.", pt: "Perfil ESG do 1T forte com melhorias contínuas de segurança." },
      miniKpis: [
        { id: "ltifr", label: { en: "LTIFR", pt: "LTIFR" }, value: "0.35", variance: "-12%", yoy: "-8%", link: "/esg" },
        { id: "env", label: { en: "Env. Incidents", pt: "Inc. Ambientais" }, value: "1", variance: "=", yoy: "=", link: "/esg" },
        { id: "rehab", label: { en: "Rehabilitation", pt: "Reabilitação" }, value: "89%", variance: "+4%", yoy: "+5%", link: "/esg" },
        { id: "community", label: { en: "Community", pt: "Comunidade" }, value: "95%", variance: "-2%", yoy: "+1.5%", link: "/esg" },
      ],
    },
  },
};
